import React, { useEffect, useMemo, useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import CookieDisclaimer from "../components/CookieDisclaimer";
import SEO from "../components/SEO";
import AnimusHeroChrome from "../components/AnimusHeroChrome";
import UpdatesTimeline, { UPDATE_TYPE_LABELS } from "../components/UpdatesTimeline";
import { apiGet } from "../api/client";
import "../styles.css";

export default function Updates() {
  const [updates, setUpdates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tool, setTool] = useState("all");
  const [type, setType] = useState("all");

  useEffect(() => {
    apiGet("/updates")
      .then(setUpdates)
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  const tools = useMemo(() => {
    const names = new Map();
    updates.forEach((u) => u.productId && u.product && names.set(u.productId, u.product.name));
    return [...names.entries()].sort((a, b) => a[1].localeCompare(b[1]));
  }, [updates]);

  const visible = updates.filter(
    (u) => (tool === "all" || u.productId === tool) && (type === "all" || u.type === type),
  );

  return (
    <>
      <SEO
        title="Tool Updates"
        description="Changelog for ZeMaxi's streaming tools: new releases, feature updates and fixes for OBS Studio and Streamer.bot tools."
        keywords="ZeMaxi updates, changelog, Streamer.bot tools, OBS overlays, release notes"
        url="https://zemaxi.com/updates"
      />
      <Navbar />
      <CookieDisclaimer />
      <main>
        <section className="videos-hero animus-hero animus-hero-bg">
          <AnimusHeroChrome />
          <div className="container">
            <p className="animus-hero-id font-mono">{'// SECTION_CHANGELOG'}</p>
            <h1>Tool <span className="highlight">Updates</span></h1>
            <p>New tools, new features and fixes, newest first.</p>
          </div>
        </section>
        <section className="page-body-section updates-page">
          <div className="container updates-page__container">
            <div className="updates-page__filters">
              <div className="category-dropdown-wrapper">
                <select className="category-dropdown" value={tool} onChange={(e) => setTool(e.target.value)} aria-label="Filter by tool">
                  <option value="all">All tools</option>
                  {tools.map(([id, name]) => <option key={id} value={id}>{name}</option>)}
                </select>
                <i className="fas fa-chevron-down category-dropdown-arrow"></i>
              </div>
              <div className="videos-category-tabs" role="tablist" aria-label="Update type">
                {["all", ...Object.keys(UPDATE_TYPE_LABELS)].map((t) => (
                  <button
                    key={t}
                    type="button"
                    role="tab"
                    aria-selected={type === t}
                    className={`videos-category-tab${type === t ? " is-active" : ""}`}
                    onClick={() => setType(t)}
                  >
                    {t === "all" ? "Everything" : UPDATE_TYPE_LABELS[t]}
                  </button>
                ))}
              </div>
            </div>
            {loading && (
              <div className="video-loading">
                <div className="spinner"></div>
                <p>Loading updates...</p>
              </div>
            )}
            {error && <div className="video-loading"><p>Failed to load updates: {error}</p></div>}
            {!loading && !error && visible.length === 0 && (
              <div className="video-loading"><p>No updates match this filter.</p></div>
            )}
            {!loading && !error && visible.length > 0 && <UpdatesTimeline updates={visible} />}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
